import { getTexts } from '../../imports'
import strings from '../../localized.json'

function getLocales() {
    return getTexts(strings)
}

export default getLocales



// WEBPACK FOOTER //
// ./src/features/Settings/data/localized/api.js